'use strict';
/**
 * 媒资库路由
 */
angular.module('resourceCenterMediaResourceModule').config(['$stateProvider', function($stateProvider) {
    $stateProvider.state('front.resourcectrl.mediaresource.resource', {
        url: '/mediaresource?resourcetype&fcode',
        views: {
            'resource@front.resourcectrl.mediaresource': {
                templateUrl: './resourceCenter/materialResource/material_main_tpl.html',
                controller: 'MediaResourceCtrl',
            }
        }
    })
}]);